import { ref as s, computed as x, onMounted as P, onBeforeUnmount as _, watch as v, openBlock as m, createElementBlock as k, normalizeClass as g, createElementVNode as y, renderSlot as b, createTextVNode as B, createCommentVNode as h } from "vue";
import { onClickOutside as I } from "./design-system.es125.js";
/* empty css                    */
import L from "./design-system.es128.js";
import { createPopper as N } from "./design-system.es297.js";
const R = {
  name: "DsPopoverLegacy",
  props: {
    /**
     * Controls the open state of the popover.  This makes the popover controlled and will not work with uncontrolled options.
     */
    isOpen: {
      type: Boolean,
      default: null
    },
    /**
     * Position of the popover, top bottom left right top-start top-end right-start right-end bottom-start bottom-end left-start left-end.
     */
    position: {
      type: String,
      default: "bottom",
      options: ["top", "right", "bottom", "left", "top-start", "top-end", "right-start", "right-end", "bottom-start", "bottom-end", "left-start", "left-end"]
    },
    /**
     * Make popover reference a block instead of default inline-block
     */
    block: Boolean,
    /**
     * Stick popper to viewport top when scrolling past view
     */
    sticky: Boolean,
    /**
     * Fix popover to window - great for getting around overflow: hidden containers
     */
    positionFixed: Boolean,
    /**
     * Whether or not to hide the arrow pointing to the reference
     */
    hideArrow: Boolean
  },
  emits: [
    "close",
    "popover-active"
  ],
  setup(r, { emit: o }) {
    const n = s(!1), t = s(null), c = s(null), i = s(null), l = s(null), a = x(() => r.isOpen === !0 || r.isOpen === !1);
    function f() {
      var e;
      n.value = !0, o("popover-active", !0), (e = t.value) == null || e.update();
    }
    function p() {
      var e;
      n.value && (n.value = !1, o("close"), o("popover-active", !1), (e = t.value) == null || e.update());
    }
    function C() {
      n.value ? p() : f();
    }
    function O() {
      a.value || C();
    }
    function u() {
      if (a.value && n.value) {
        o("close");
        return;
      }
      p();
    }
    return I(
      l,
      u,
      { ignore: [i] }
    ), P(() => {
      const {
        position: e,
        positionFixed: w,
        sticky: d
      } = r;
      t.value = N(i.value, l.value, {
        placement: e,
        strategy: w ? "fixed" : "absolute",
        modifiers: [
          {
            name: "eventListeners",
            options: {
              scroll: !0,
              resize: !0
            }
          },
          {
            name: "preventOverflow",
            options: {
              tether: !d,
              boundary: d ? "viewport" : "scrollParent"
            }
          },
          {
            name: "offset",
            options: {
              offset: [0, 8]
            }
          }
        ]
      });
    }), _(() => {
      var e;
      (e = t.value) == null || e.destroy();
    }), v(() => r.isOpen, (e) => {
      e ? f() : p();
    }, { immediate: !0 }), v(() => r.position, (e) => {
      t.value.options.placement = e;
    }), {
      isOpenInternal: n,
      popperJs: t,
      target: c,
      reference: i,
      popover: l,
      isControlled: a,
      onReferenceClick: O,
      onBodyClick: u
    };
  }
}, V = {
  key: 0,
  "data-popper-arrow": "",
  class: "arrow"
};
function z(r, o, n, t, c, i) {
  return m(), k("div", {
    class: g(["popover-container", [{ block: n.block }]])
  }, [
    y("div", {
      ref: "reference",
      class: "popover-reference",
      onClick: o[0] || (o[0] = (...l) => t.onReferenceClick && t.onReferenceClick(...l))
    }, [
      b(r.$slots, "reference")
    ], 512),
    o[2] || (o[2] = B()),
    y("section", {
      ref: "popover",
      class: g(["popover", { open: t.isOpenInternal }])
    }, [
      n.hideArrow ? h("", !0) : (m(), k("div", V)),
      o[1] || (o[1] = B()),
      b(r.$slots, "default")
    ], 2)
  ], 2);
}
const J = /* @__PURE__ */ L(R, [["render", z], ["__scopeId", "data-v-a641a16f"]]);
export {
  J as default
};
//# sourceMappingURL=design-system.es312.js.map
